import { render, staticRenderFns } from "./combination-item.vue?vue&type=template&id=3aa7eeb6&"
import script from "./combination-item.vue?vue&type=script&lang=js&"
export * from "./combination-item.vue?vue&type=script&lang=js&"
import style0 from "./combination-item.vue?vue&type=style&index=0&id=3aa7eeb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports